import { useUserStore } from '../userStore';
import { fetchUser, fetchUserMarksByIds } from '../../hooks/api/userAPI';
import { handleError } from '../../hooks/managers/errorHandler';
import { User, UserMark } from '../userStore';
import { bffAuthService } from '../../services/BffAuthService';

// 定义异步操作接口
export interface UserAsyncActions {
  fetchUserAsync: () => Promise<User | null>;
  fetchUserMarksAsync: (userIds: string[]) => Promise<UserMark[]>;
  updateUserGroupAsync: (userGroup: any) => Promise<void>;
  resetPasswordAsync: (password: string) => Promise<boolean>;
}

// 创建异步actions工厂函数
export const createUserAsyncActions = (): UserAsyncActions => {
  const { setCurrentUser, setUserMarks, setStatus, setError } = useUserStore.getState();
  
  return {
  fetchUserAsync: async () => {
     try {
       setStatus('loading');
       setError(null);
       
       const user = await fetchUser();
       
       if (user) {
         let enrichedUser = user;
         if (!user.userId) {
           console.log('=== userActions.fetchUserAsync: 补充 userId ===');
           console.log('原始 user:', user);
           
           let userInfo = bffAuthService.getUserInfo();
           if (!userInfo) {
             console.log('bffAuthService.getUserInfo() 为 null，尝试 fetchUserInfo()');
             userInfo = await bffAuthService.fetchUserInfo();
           }
           
           if (userInfo && userInfo.sub) {
             enrichedUser = {
               ...user,
               userId: String(userInfo.sub)
             };
             console.log('补充后的 user (已添加 userId):', enrichedUser);
           } else if (user._id) {
             enrichedUser = {
               ...user,
               userId: String(user._id)
             };
             console.log('使用 _id 作为 userId:', enrichedUser);
           }
         }
         
         setCurrentUser(enrichedUser);
         setStatus('idle');
         return enrichedUser;
       } else {
         setStatus('idle');
         return null;
       }
     } catch (error) {
       handleError(error, { context: 'fetchUserAsync执行失败' });
       setStatus('failed');
       setError('获取用户信息失败');
       throw error;
     }
   },


   fetchUserMarksAsync: async (userIds) => {
    try {
      setStatus('loading');
      setError(null);
      
      const numericIds = userIds.map(id => Number(id)).filter(id => !isNaN(id));
      const response = await fetchUserMarksByIds(numericIds);
       // 从API响应中提取data字段，因为API返回的是完整响应对象
       const userMarks = response.data || response;
       // 完全覆盖原来的userMarks数据，作为临时数据使用
       setUserMarks(userMarks);
       setStatus('idle');
       return userMarks;
     } catch (error) {
       handleError(error, { context: 'fetchUserMarksAsync执行失败' });
       setStatus('failed');
       setError('获取用户标记失败');
       throw error;
     }
   },

   updateUserGroupAsync: async (userGroup) => {
     try {
       // 这里应该调用更新用户组的API
       // 暂时只记录日志
     } catch (error) {
       handleError(error, { context: `updateUserGroupAsync执行失败: userGroupId ${userGroup.guid}` });
       throw error;
     }
   },

   resetPasswordAsync: async (password) => {
     try {
       // 注意：userId应该作为参数传入，而不是从store获取
       // 这里暂时返回true，实际实现时需要调用API
       // const success = await resetPassword(userId, password);
       return true;
     } catch (error) {
       handleError(error, { context: 'resetPasswordAsync执行失败' });
       throw error;
     }
   }
  };
};

// 导出异步actions对象（向后兼容）
export const userAsyncActions = createUserAsyncActions();